<template>
    <v-dialog v-model="dialog" width="500" persistent>
        <v-card>
            <v-card-title class="headline lighten-2" :class="header_class" primary-title>
                {{title}}
            </v-card-title>
            <v-card-text>
                {{text}}
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="$emit('approve')">
                    {{confirm_button_text}}
                </v-btn>
                <v-btn color="red" flat @click="$emit('decline')">
                    {{decline_button_text}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "ConfirmDialog",
        props: {
            header_class: {
                default: 'primary'
            },
            visible: {
                default: false,
                type: Boolean
            },
            title: {
                default: 'Confirm'
            },
            text: {
                default: 'Are you sure you want to continue?'
            },
            confirm_button_text: {
                default: 'Yes'
            },
            decline_button_text: {
                default: 'No'
            },
        },
        model: {
            prop: 'visible',
            event: 'visible_change'
        },
        computed: {
            dialog: {
                get: function () {
                    return this.visible
                },
                set: function (value) {
                    this.$emit('visible_change', value)
                }
            }
        }
    }
</script>

<style scoped>

</style>